function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_975",
  "data-name": "Group 975",
  transform: "translate(-528.495 -473.658)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1434",
  "data-name": "Rectangle 1434",
  transform: "translate(536.818 479.426) rotate(40)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 11.33,
  height: 12.948,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 10.33,
  height: 11.948,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1435",
  "data-name": "Rectangle 1435",
  transform: "translate(541.789 473.658) rotate(40)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 11.33,
  height: 6.474,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 10.33,
  height: 5.474,
  fill: "none"
})));

function SvgMenuClosedBetslip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.973,
    height: 22.97,
    viewBox: "0 0 21.973 22.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClosedBetslip);
export default __webpack_public_path__ + "static/media/menu-closed-betslip.52912c50.svg";
export { ForwardRef as ReactComponent };